import CarrierImage from './CarrierImage'

export default CarrierImage
